import type { Href } from 'expo-router';

type NotificationData = Record<string, unknown> | undefined;

const NOTIFICATION_ROUTE_BY_TYPE: Record<string, Href> = {
  morning_perdiem: '/(app)/budget',
  large_transaction: '/(app)/transactions',
  large_purchase: '/(app)/transactions',
  large_trade: '/(app)/holdings',
  'fire-recalc': '/(app)/fire-plan',
  fi_milestone: '/(app)/fire-plan',
  fi_health_review: '/(app)/fire-plan',
  fi_health_recovery: '/(app)/fire-plan',
  fi_year_change: '/(app)/fire-plan',
  review_transactions: '/(app)/transactions',
};

export function getNotificationTargetRoute(data: NotificationData): Href | null {
  if (!data) return null;

  const type = data['type'];
  if (typeof type !== 'string') return null;

  // Transport the "needs review" filter through a query param on the
  // transactions route so the screen opens with the filter already applied.
  if (type === 'review_transactions') {
    return { pathname: '/(app)/transactions', params: { needsReview: '1' } } as Href;
  }

  // Large trade alerts should land directly on the activity tab of the
  // portfolio screen, since the trade itself is what the user tapped to see.
  if (type === 'large_trade') {
    return { pathname: '/(app)/holdings', params: { tab: 'activity' } } as Href;
  }

  const route = data['route'];
  if (typeof route === 'string' && route === NOTIFICATION_ROUTE_BY_TYPE[type]) {
    return route as Href;
  }

  return NOTIFICATION_ROUTE_BY_TYPE[type] ?? null;
}
